var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4783 34L21.604 14.1842L21.6277 14.2027L34.1374 0H29.957L19.7662 11.56L11.6736 0H0.709869L13.6628 18.5007L13.6613 18.4991L0 34H4.18041L15.5101 21.1387L24.5146 34H35.4783ZM10.0172 3.0909L29.4837 30.9091H26.1709L6.68869 3.0909H10.0172Z",
    fill: "#F9F5EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.820535d01837bca79ed5d12b399ca7bd.svg";
export { ForwardRef as ReactComponent };